/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespHeroBannerText_heroBannerSettings = {
    readonly contentPosition: string | null;
    readonly textAlignment: string | null;
    readonly contentColor: string | null;
    readonly eyeBrowText: string | null;
    readonly headerText: string | null;
    readonly headerStyle: string | null;
    readonly dekText: string | null;
    readonly ctaStyle: string | null;
    readonly " $refType": "HpRespHeroBannerText_heroBannerSettings";
};
export type HpRespHeroBannerText_heroBannerSettings$data = HpRespHeroBannerText_heroBannerSettings;
export type HpRespHeroBannerText_heroBannerSettings$key = {
    readonly " $data"?: HpRespHeroBannerText_heroBannerSettings$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespHeroBannerText_heroBannerSettings">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespHeroBannerText_heroBannerSettings",
  "type": "HeroBannerSettingsType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contentPosition",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "textAlignment",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contentColor",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "eyeBrowText",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "headerText",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "headerStyle",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "dekText",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "ctaStyle",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '186f9e4073c5ff6082d7be6e203c0765';
export default node;
